import { ChangeDetectionStrategy, Component, ElementRef, Input, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { EnumMeasureTypes, Measure } from '@library/store/measures/measures.interface';
import { BarChart, LineChart, Svg } from 'chartist';

@Component({
  selector: 'app-preview-graph',
  templateUrl: './preview-graph.component.html',
  styleUrls: ['./preview-graph.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewGraphComponent {

  id = `ct-${Math.round(Math.random() * 1000000)}`;

  @Input() data: Measure[];
  @Input() color: string;
  @Input() measureType: EnumMeasureTypes;

  private chart: LineChart | BarChart;

  @ViewChild('preview') preview: ElementRef<HTMLDivElement>;

  ngOnChanges(sc: SimpleChanges) {
    if (this.preview && sc.data) {
      this.createPreview(this.data);
    }
  }

  ngAfterViewInit() {
    this.createPreview(this.data);
  }

  createPreview(data: Measure[]) {

    switch (this.measureType) {
      case EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_BASE:
      case EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_PRICE_BASE:
      case EnumMeasureTypes.SUM_FLUID_CONSUMPTION_GAS:
      case EnumMeasureTypes.SUM_FLUID_PRICE_GAS:
      case EnumMeasureTypes.SUM_FLUID_CONSUMPTION_COLD_WATER:
      case EnumMeasureTypes.SUM_FLUID_PRICE_COLD_WATER:
        this.chart = new BarChart(
          `#${this.id}`,
          {
            series: [data]
          },
          CHART_OPTIONS
        );
        break;
      default: {
        this.chart = new LineChart(
          `#${this.id}`,
          {
            series: [data]
          },
          CHART_OPTIONS
        );
        break;
      }
    }

    this.chart.on('created', (data) => {
      const defs = new Svg('defs');
      const gradient = defs.elem('linearGradient', { 'id': `${this.id}-area-gradient]`, 'x1': '0%', 'y1': '0%', 'x2': '0%', 'y2': '100%' });

      gradient.elem('stop', { 'offset': 0, 'stop-color': this.color });
      gradient.elem('stop', { 'offset': 20, 'stop-color': this.color, 'stop-opacity': '0' });

      data.svg.append(defs, true);

      data.svg.querySelector('.ct-series')
        .removeClass('ct-series-a')
        .attr({
          'stroke': this.color,
        });

      if (data.svg.querySelector('.ct-series .ct-area')) {
        data.svg.querySelector('.ct-series .ct-area')
          .attr({
            'fill': `url(#${this.id}-area-gradient])`,
          });
      }

      // Set the min height of the bars to 2 pixels
      data.svg.querySelectorAll('.ct-series .ct-bar').svgElements.forEach(e => {
        if (e._node.y1.baseVal.value === e._node.y2.baseVal.value) {
          e._node.y2.baseVal.value = e._node.y1.baseVal.value - 2;
        }
      });

    });

  }

}

const CHART_OPTIONS = {
  showArea: true,
  showPoint: false,
  fullWidth: true,
  height: '60px',
  width: '140px',
  chartPadding: {
    left: 0,
    right: 0,
  },
  axisX: {
    showLabel: false,
    showGrid: false,
    offset: 0
  },
  axisY: {
    showLabel: false,
    showGrid: false,
    offset: 0
  },
};
